
































import { Vue, Component, Prop } from 'vue-property-decorator'
import { AppUpdate } from '@robingenz/capacitor-app-update'
import { Capacitor } from '@capacitor/core'

@Component
export default class AppUpdateDialog extends Vue {
  @Prop({ default: false }) readonly opened!: boolean

  currentVersion = ''

  closeDialog() {
    this.$store.commit('SET_UPDATE_DIALOG_VISIBLE', false)
  }

  mounted() {
    this.getCurrentVersion()
  }

  async getCurrentVersion() {
    const appUpdateInfo = await AppUpdate.getAppUpdateInfo()
    this.currentVersion = appUpdateInfo.currentVersion
  }

  async updateApp() {
    if (Capacitor.getPlatform() === 'android') {
      await AppUpdate.performImmediateUpdate()
    }
    else {
      await AppUpdate.openAppStore()
    }
  }
}
